const blank = "https://static.vecteezy.com/system/resources/previews/001/921/566/non_2x/businessman-elegant-with-infographic-presentation-free-vector.jpg"

export const officers = [
    {
        name: "Everett Richards",
        position: "President",
        email: "erichards5198@sdsu.edu",
        url: "https://everettrichards.com",
        major: "Computer Science & Applied Math",
        committees: ["Finance","Recruitment & Public Relations","Workshops & Curricula"],
        photo: require("../images/officers/everett_old.jpg"),
    },
    {
        name: "Jake Basile",
        position: "Executive Vice President",
        email: "jbasile0009@sdsu.edu",
        major: "Statistics, emph. Data Science",
        committees: ["Finance","Workshops & Curricula"],
        photo: require("../images/officers/jake.JPG"),
    },
    {
        name: "Nitin Chatlani",
        position: "Vice President of Operations",
        email: "nchatlani5481@sdsu.edu",
        major: "Computer Science",
        committees: ["Recruitment & Public Relations","Workshops & Curricula"],
        photo: require("../images/officers/nitin.png")
    },
    {
        name: "Tanish Gheewala",
        position: "Treasurer",
        email: "tgheewala4792@sdsu.edu",
        major: "Computer Engineering",
        committees: ["Finance"],
        photo: require("../images/officers/tanish.png")
    },
    {
        name: "Ian Beard",
        position: "Vice President of Public Relations",
        email: "ibeard5884@sdsu.edu",
        major: "Astronomy",
        committees: ["Recruitment & Public Relations"],
        photo: require("../images/officers/ian.png"),
    },
    {
        name: "Isabella King",
        position: "Vice President of Marketing",
        email: "iking4380@sdsu.edu",
        major: "Computer Science",
        committees: ["Recruitment & Public Relations","Workshops & Curricula"],
        photo: require("../images/officers/bella.png"),
    },
    {
        name: "JP Zendejas",
        position: "Secretary",
        email: "jzendejas1726@sdsu.edu",
        major: "Computer Science",
        committees: ["Workshops & Curricula"],
        photo: require("../images/officers/jp.png")
    },
    {
        name: "Miranda Parker",
        position: "Faculty Advisor",
        url: "https://mirandacparker.com/",
        major: "Professor of Computer Science",
        committees: ["N/A"],
        photo: require("../images/officers/parker.jpeg")
    },
]

// export const guests = [
//     {
//         name: "Jaxon Hill",
//         expertise: "Web Scraping, Modern Web Development, Real-World Applications",
//         email: "jhill4135@sdsu.edu",
//         status: "Undergraduate",
//         knownfor: "Created a web scraper, fastclass.io, for the SDSU course catalog",
//         photo: blank
//     },
// ]